import React, { useState } from "react";
import AppPdf from "../../pdf/POS Application Certification Documents.pdf";
import DevicePdf from "../../pdf/POS Device Certification Documents.pdf";
import Download from "../../assets/assets/download-pdf.svg";
import UserModal from "../../components/EmailModal/UserModal";
import { PropTypes } from "prop-types";

const POSRequirement = ({type}) => {
  const [state, setState] = useState({
    viewModal: false,
  });

  const openModal = () => {
    setState({
      ...state,
      viewModal: true,
    });
  };

  const closeModal = () => {
    setState({
      ...state,
      viewModal: false,
    });
  };

  return (
    <>
      <div className="download-btn">
        <button data-testid="openModal" onClick={openModal}>
          <img src={Download} alt="download" /> &nbsp; &nbsp; View Requirement
        </button>

        <UserModal
          open={state.viewModal}
          close={closeModal}
          height={"739"}
          width={"1000"}
        >
          <div style={{ padding: "20px" }}>
            <span className="iframe-back2" data-testid="closeModal" onClick={() => closeModal()}>
              X
            </span>
            <embed
              src={type === "application" ? AppPdf : DevicePdf}
              type="application/pdf"
              width="100%"
              height="1000"
              title="Required Documents"
              name="Required Documents"
            ></embed>
          </div>
        </UserModal>
      </div>
    </>
  );
};

POSRequirement.propTypes = {
  type: PropTypes.string
}

export default POSRequirement;
